import HostApi from "../../../../data/settings/HostApi";
import UserImplDto from "../../../../data/dto/impl/UserImplDto";
import UserEntity from "../../../../domain/entities/UserEntity";
import { identifyMixpanelUser } from "../../../../lib/mixpanel";

/** Login con correo y contraseña (`/login/`): guarda el token e identifica al usuario en Mixpanel. */
export const loginConCorreo = async (email: string, password: string): Promise<UserEntity> => {
    const res = await HostApi.post("/login/", { email, password });
    HostApi.setToken(res.token);
    const user = UserImplDto.fromJson(res.user);
    // Antes de cualquier evento de sesión, o quedaría anónimo (el provider identifica en un efecto, después).
    identifyMixpanelUser(String(user.id));
    return user;
};
